 class DragController {
  constructor(splitDragObj) {
    this.splitDragResize = splitDragObj.splitDragResize; //  上下分屏拖动 中间的div的id
    this.splitDragTop = splitDragObj.splitDragTop; //  上下分屏  上半屏的div的id
    this.splitDragDown = splitDragObj.splitDragDown; //  上下分屏 下半屏的div的id
    this.splitDragBox = splitDragObj.splitDragBox; //  上下分屏  最外层容器的div的id
  }
  dragControllerDiv() {
    var splitDragResize = document.getElementById(this.splitDragResize);
    var splitDragTop = document.getElementById(this.splitDragTop);
    var splitDragDown = document.getElementById(this.splitDragDown);
    var w = window.innerWidth;
    var splitDragBox = document.getElementById(this.splitDragBox);
    splitDragBox.style.width = w + "px";
    splitDragResize.onmousedown = function (e) {
      var startX = e.clientX;
      splitDragResize.left = splitDragResize.offsetLeft;
      document.onmousemove = function (e) {
        var endX = e.clientX;
        var moveLen;
        if (splitDragResize.left + (endX - startX) <= 160) {
          moveLen = 160;
        } else if (splitDragResize.left + (endX - startX) >= splitDragBox.clientWidth - 165) {
          moveLen = splitDragBox.clientWidth - 165;
        } else {
          moveLen = splitDragResize.left + (endX - startX);
        }
        var maxT = splitDragBox.clientWidth - splitDragResize.offsetWidth;
        if (moveLen < 30) moveLen = 30;
        if (moveLen > maxT - 30) moveLen = maxT - 30;
        splitDragResize.style.left = moveLen;
        splitDragTop.style.width = moveLen + "px";
        splitDragDown.style.width = (splitDragBox.clientWidth - moveLen - 5) + "px";
      }
      document.onmouseup = function () {
        document.onmousemove = null;
        document.onmouseup = null;
        splitDragResize.releaseCapture && splitDragResize.releaseCapture();
      }
      splitDragResize.setCapture && splitDragResize.setCapture();
      return false;
    }
  }
}

export default DragController;
